var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h100" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "leftMenu",
        style: _vm.isBotBut ? "height: calc(100% - 40px);" : "",
      },
      [
        _c(
          "el-menu",
          {
            key: _vm.activeIndex,
            ref: "menuTree",
            staticClass: "el-menu-vertical-demo",
            staticStyle: { height: "100%" },
            attrs: { "default-active": _vm.activeIndex },
            on: { select: _vm.MenuSelect },
          },
          _vm._l(_vm.MenuList, function (item) {
            return _c(
              item.Type == 3 ? "el-menu-item" : "el-submenu",
              {
                key: item.Id,
                tag: "component",
                attrs: {
                  index: JSON.stringify({
                    BuildingId: item.BuildingId || "",
                    DeviceType: item.Id || "",
                    InstallationArea: item.InstallationArea || "",
                    TreeType: item.TreeType || 0,
                  }),
                },
              },
              [
                _c("template", { slot: "title" }, [
                  _c("i", { staticClass: "el-icon-office-building" }),
                  _c("span", [_vm._v(_vm._s(item.title))]),
                ]),
                _vm._l(item.Children, function (ele) {
                  return _c(
                    ele.Type == 4 ? "el-submenu" : "el-menu-item",
                    {
                      key: ele.title,
                      tag: "component",
                      attrs: {
                        index: JSON.stringify({
                          BuildingId: ele.BuildingId || "",
                          DeviceType: ele.Id || "",
                          InstallationArea: ele.InstallationArea || "",
                          TreeType: ele.TreeType || 0,
                        }),
                        "popper-class": "popper-menu",
                      },
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("i", {
                          class:
                            ele.Type == 4
                              ? "el-icon-school"
                              : "el-icon-edit-outline",
                        }),
                        _c("span", [_vm._v(_vm._s(ele.title))]),
                      ]),
                      ele.Children && ele.Children.length > 0
                        ? _vm._l(ele.Children, function (v) {
                            return _c(
                              "el-menu-item",
                              {
                                key: v.Id,
                                staticClass: "menu-item",
                                attrs: {
                                  index: JSON.stringify({
                                    BuildingId: v.BuildingId || "",
                                    DeviceType: v.Id || "",
                                    InstallationArea: v.InstallationArea || "",
                                    TreeType: v.TreeType || 0,
                                  }),
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-edit-outline",
                                }),
                                _c(
                                  "span",
                                  { attrs: { slot: "title" }, slot: "title" },
                                  [_vm._v(_vm._s(v.title))]
                                ),
                              ]
                            )
                          })
                        : _vm._e(),
                    ],
                    2
                  )
                }),
              ],
              2
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm.isBotBut
      ? _c(
          "div",
          { staticClass: "tabsBut" },
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                on: { "tab-click": _vm.menuChange },
                model: {
                  value: _vm.TreeType,
                  callback: function ($$v) {
                    _vm.TreeType = $$v
                  },
                  expression: "TreeType",
                },
              },
              [
                _c("el-tab-pane", { attrs: { label: "楼栋", name: "0" } }),
                _c("el-tab-pane", { attrs: { label: "机房", name: "1" } }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }